let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("futb7")).then(() => parcelRequire('5Bldy'));